export const state = {
    // Auth/session
    isAnonymous: true,
    userId: null,
    isAdmin: false,
    adminRole: null,

    // Job Data
    jobId: Math.random().toString(36).substring(7),
    targetFilename: "",
    targetJobId: null,
    statusInterval: null,
    lastShownSettings: null,
    currentJobStartedAtMs: null,
    currentJobFirstProgressAtMs: null,
    currentJobSimpleDetailExtreme: '',

    // Library Data (NEW)
    selectedLibraryId: null,
    libraries: [],

    // Upload State
    uploadQueue: [],
    uploadCursor: 0,

    // X-Ray
    tileMap: [],

    // Main source photos
    sourcePhotos: [],
    hasUploadedSourceThisSession: false,
    selectedSourcePhotoId: null,
    selectedSourcePhoto: null,

    // Selected recent mosaic highlight
    selectedHistoryJobId: null,
    selectedHistoryJob: null,
    viewerJobId: null,

    // Settings visibility override for "Use same settings"
    forceShowSettings: false,
    mainPhotoCollapsed: false,
    tileLibraryCollapsed: false,
    settingsCollapsed: false,
    historyCollapsed: false,
    createMosaicCollapsed: false,
    viewerCollapsed: false,
    viewerForceOpen: false,
    lastMainReady: false,
    lastLibrarySelected: false,
    mainPhotoEngaged: false,
    libraryEngaged: false,
    settingsEngaged: false,
    settingsPrompt: false,
    settingsHadSelection: false,
    mainPhotoPending: false,
    libraryPending: false,

    lastShownSourceInfo: null,

    // History (recent mosaics)
    history: [],
    historyOffset: 0,
    historyLimit: 24,
    historyHasMore: true,
    historyLoading: false,
    historyCursor: null,
    historyTotal: null,
    historyLifetimeTotal: null,
    historyRetention: null,
    historySoftWarningKey: '',
    historyBootStatus: 'loading', // loading|loaded|error
    // Plan limits
    plan: null,
    planDailyJobLimit: null,
    planJobsStartedToday: 0,
    planRemainingJobs: null,
    billingStatus: null,
    refactorRollout: {
        billingMode: 'refactor',
        viewerMode: 'refactor',
    }
};
